export function generateSearchUrlWithTransport(currentUrl: string | URL, transportId: string) {
  const url = new URL(currentUrl);
  const params = url.searchParams;

  // TODO check if a bfSubSource is needed

  const paramsToKeep = [
    'adults',
    'businessProfileId',
    'dateFrom',
    'dateTo',
    'destination',
    'origin',
    'pageType',
    'searchId',
    'searchMode',
    'source',
    'vc_searchId',
  ];

  const newParams = new URLSearchParams();
  paramsToKeep.forEach((param) => {
    if (params.has(param)) {
      newParams.set(param, params.get(param) || '');
    }
    newParams.set('pageType', 'search');
    newParams.set('transportId', transportId);
  });

  const newUrl = `${url.origin}${url.pathname}?${newParams.toString()}`;
  return newUrl;
}
